<template>
  <div style="padding:20px">
    <div class="search_box">
      <div>
        <el-input v-model="pageIfon.keywords" style="width:200px;margin-right:10px" placeholder="公众号" />
        <el-select v-model="pageIfon.tag_group_id" placeholder="请选择" @change="changeSelect">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.tag_group_name"
            :value="item.id"
          />
        </el-select>
        <!-- <el-button icon="el-icon-search" type="primary" style="margin-left:10px" @click="(pageIfon.page = 1),(resultlist())">搜索</el-button> -->
        <el-button icon="el-icon-search" type="primary" style="margin-left:10px" @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh-left" type="info" style="max-height:37px" @click="reset">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="add()">新增</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="account_name"
        label="公众号"
        width="300"
        align="center"
      />
      <el-table-column
        prop="tag_group_name"
        label="标签组"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.tag_group_name }}({{ scope.row.tag_group_id }})
        </template>
      </el-table-column>
      <el-table-column
        prop="use_count"
        label="标签的用户数"
        width="200"
        align="center"
      />
      <el-table-column
        prop="wechat_tag_id"
        label="微信标签id"
        width="200"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        align="center"
      />
      <!-- <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template>
          <el-button type="danger" size="mini">删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-dialog
      title="公众号标签"
      :visible.sync="dialogVisible"
      width="30%"
      :destroy-on-close="true"
    >
      <addlabelmanagement ref="addanonview" @updata="updata" />
      <!-- <addlabelmanagement @updata="updata" /> -->
    </el-dialog>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { listForLabelOfofficialaccount, delerroralarm, listForOfficialTags } from '@/api/sourceMaterial.js'
import addlabelmanagement from './components/addlabelmanagement.vue'
export default {
  name: 'Anonymousletter',
  components: {
    PaginationRight,
    addlabelmanagement
  },
  data() {
    return {
      pageIfon: {
        page: 1,
        pageSize: 10,
        keywords: null,
        tag_group_id: null
      },
      total: null,
      tableData: [],
      listData: [],
      id: null,
      dialogVisible: false,
      options: []
    }
  },
  created() {
    this.resultlist()
    // this.typelist()
    this.OfficialTagslist()
    // this.OfficialAccountlist()
  },
  mounted() {

  },
  methods: {
    send(val) {
      console.log('val', val)
      this.id = val
      // this.resultlist()
    },
    async resultlist() {
      const data = await listForLabelOfofficialaccount(this.pageIfon)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data.data.list)
    },
    async OfficialTagslist() {
      const data = await listForOfficialTags()
      this.options = data.data.list
      // this.total = data.data.total
      console.log('list data', data.data.list)
    },
    // async OfficialAccountlist() {
    //   const data = await listForOfficialAccount(this.pageIfon)
    //   this.listData = data.data.list
    //   // this.total = data.data.total
    //   console.log('OfficialAccountlist', data.data.list)
    // },
    add() {
      this.dialogVisible = true
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.resultlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.resultlist()
    },
    reset() {
      // this.pageIfon = {
      //   page: 1, // 页码
      //   pageSize: 10 // 页数
      // }
      this.pageIfon.page = 1
      this.pageIfon.keywords = null
      this.pageIfon.tag_group_id = null
      this.resultlist()
    },
    updata() {
      this.dialogVisible = false
      this.resultlist()
    },
    deleter(id) {
      this.$confirm('确定要删除吗？是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        delerroralarm({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          // this.resultlist()
        })
      }).catch(() => {
        console.log('出错了')
      })
    },
    changeSelect(val) {
      console.log('val', val)
    },
    search() {
      console.log('pageIfon.keywords', this.pageIfon.keywords)
      console.log('options', this.options)
      console.log('')
      this.pageIfon.page = 1
      this.pageIfon.pageSize = 10
      this.resultlist()
    }
  }
}
</script>
<style scoped>
  /* @import url(); 引入css类 */
  .defaultr{
    color: #67C23A;
  }
  .stopew{
    color: red;
  }
  .search_box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:10px
  }
</style>
